<template>
    <div class="page-wirtschaftlichkeit-config">
        <div class="col-md-3 col-lg-2 d-md-block bg-light sidebar">
            <NavPlantsSidebar v-if="plantsLoaded" v-bind="currentPlantsProperties"
                v-on:setPlant="setEconomicPlant"></NavPlantsSidebar>
        </div>
        <div class="col-md-9 ms-sm-auto col-lg-10">
            <template v-if="this.currentPlant">
                <div class="container-fluid my-3">
                    <h4>{{ $t("wirtschaftlichkeit_config") }} - {{ currentPlant.name }}</h4>

                    <EconomicConfig
                        :plant="currentPlant"
                        :economicConfig="economicConfig"
                        :allDescriptions="getAllPlantDescriptionOptions"
                        @configSaved="onConfigSaved"
                    ></EconomicConfig>
                </div>
            </template>
            <template v-else>
                <div class="card mt-3">
                    <div class="card-body">
                        <p class="text-muted">{{ $t("select_plant_for_economic_config") }}</p>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import EconomicConfig from '@/components/wirtschaftlichkeit/EconomicConfig.vue'
import NavPlantsSidebar from '@/components/navs/NavPlantsSidebar.vue'
import apiClient from '@/services/apiClient'

export default {
    name: 'WirtschaftlichkeitConfig',
    components: {
        EconomicConfig,
        NavPlantsSidebar
    },
    data() {
        return {
            currentPlant: null,
            economicConfig: null,
            loading: false
        }
    },
    watch: {
        currentPlant: {
            handler(newVal) {
                if (newVal && newVal.id) {
                    this.loadEconomicConfig()
                }
            },
            immediate: true
        }
    },
    methods: {
        setEconomicPlant(plant) {
            this.currentPlant = plant
        },
        async loadEconomicConfig() {
            this.loading = true
            try {
                const response = await apiClient.getEconomicConfigForPlant(this.currentPlant.id)
                this.economicConfig = response.data
            } catch (error) {
                console.error('Error loading economic config:', error)
                this.economicConfig = {
                    plant: this.currentPlant.id,
                    plant_name: this.currentPlant.name,
                    production_kwh_field: null,
                    annual_target_kwh: 0,
                    electricity_prices: [],
                    monthly_distributions: [],
                    exists: false
                }
            } finally {
                this.loading = false
            }
        },
        onConfigSaved(newConfig) {
            this.economicConfig = newConfig
            this.economicConfig.exists = true
        }
    },
    computed: {
        plantsLoaded() {
            return !!this.$store.getters.getPlants
        },
        currentPlantsProperties() {
            return {
                plants: this.$store.getters.getPlants,
                showPlantComponents: false,
                editPlantComponents: false,
                editPlants: false
            }
        },
        getAllPlantDescriptions() {
            let allPlantDescriptions = []
            if (!this.currentPlant || !this.currentPlant.plant_components) {
                return allPlantDescriptions
            }
            this.currentPlant.plant_components.forEach(component => {
                component.component_data_description.forEach(data_description => {
                    data_description.component_name = component.name
                })
                if (allPlantDescriptions.length === 0) {
                    allPlantDescriptions = component.component_data_description
                } else {
                    allPlantDescriptions = allPlantDescriptions.concat(component.component_data_description)
                }
            })
            allPlantDescriptions = allPlantDescriptions.sort((a, b) => {
                if (a.component < b.component) return -1
                if (a.component > b.component) return 1
                if (a.col_description.toUpperCase() < b.col_description.toUpperCase()) return -1
                if (a.col_description.toUpperCase() > b.col_description.toUpperCase()) return 1
                return 0
            })
            return allPlantDescriptions
        },
        getAllPlantDescriptionOptions() {
            var allPlantDescriptionsRaw = this.getAllPlantDescriptions
            let allPlantDescriptions = []
            allPlantDescriptionsRaw.forEach(description => {
                allPlantDescriptions.push({
                    value: description.id,
                    text: description.component_name + " - " + description.col_description
                })
            })
            return allPlantDescriptions
        }
    }
}
</script>
